<!--
 * @Descripttion: 
 * @version: 
 * @Author: Jeson
 * @Date: 2021-06-07 09:41:24
 * @LastEditors: Jeson
 * @LastEditTime: 2021-09-24 09:17:27
-->
// 购物车商品标签
<template>
    <div class="custom-tag"
         :style="{background: bgColor+''}">{{text}}</div>
</template>
<script>
export default {
    name: '',
    mixins: [],
    components: {},
    // 数据部分
    props: {
        bgColor: {
            type: String,
            default: '#490FEA'
        },
        text: {
            type: String,
            default: '新品'
        }
    },
    data () {
        return {};
    },
    computed: {},
    watch: {
    },
    // 生命周期
    created () { },
    mounted () { },
    unmounted () { },
    // 方法
    methods: {},
}; 
</script>
<style lang="less" scoped>
.custom-tag {
    // width: 80px;
    flex-shrink: 0;
    box-sizing: border-box;
    color: #fff;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 0 4px;
    font-size: 12px;
    margin-right: 8px;
    line-height: 16px;
}
</style>